// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const ToastContract = contract({
  name: "Toast",
  description: "Transient, non-blocking feedback that confirms or warns about an action — \"Saved\", \"Failed to upload\", \"Copied to clipboard\", \"Invitation sent\". For permanent inline messages reach for Callout. For confirmations that block until acknowledged use Dialog. Mount <Toaster /> ONCE at the root of the app; everywhere else, call the `toast` helper.",
  import: "@gradeui/ui",
  aliases: ["toast","toaster","sonner","notification","snackbar","alert toast","transient alert","transient banner","banner notification","toastandroid"],
  composesWith: ["App root layout (single <Toaster /> mount)","Form submit handlers (success/error toasts)","Async actions"],
  props: {
  "position": {
      schema: z.enum(["top-left", "top-center", "top-right", "bottom-left", "bottom-center", "bottom-right"]).optional(),
      design: "knob",
      default: "bottom-right",
  },
  "theme": {
      schema: z.enum(["light", "dark", "system"]).optional(),
      design: "knob",
  },
  "richColors": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "colored variants for success/error/warning/info",
  },
  "expand": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "keep multiple toasts visually separated rather than stacked",
  },
  "visibleToasts": {
      schema: z.number().optional(),
      design: "knob",
      description: "max concurrent toasts on screen (default 3)",
  },
  "duration": {
      schema: z.number().optional(),
      design: "knob",
      description: "default ms before auto-dismiss",
  },
  },
});
